import { ConversationMessage } from 'features/chatbot/types/conversation'
import { SerializedConversationMessage } from 'types'

/**
 * Converts a serialized conversation message (from rolodex storage)
 * back into the runtime ConversationMessage format.
 */
function deserializeMessage(
  msg: SerializedConversationMessage
): ConversationMessage {
  switch (msg.type) {
    case 'thought':
    case 'error':
    case 'userMessage':
      return { type: msg.type, text: msg.text ?? '' }
    case 'aiResponse':
      return {
        type: 'aiResponse',
        naturalLanguageResponseBySegments: [
          { text: msg.naturalLanguageResponse ?? '', citations: [] },
        ],
        sources: msg.sources,
        thinkingTimeSeconds: msg.thinkingTimeSeconds,
        thinkingNotes: msg.thinkingNotes?.map((note) => ({
          text: note.text,
          sources: note.sources,
        })),
        instrumentsWithData: msg.instrumentsWithData,
      }
  }
}

/**
 * Converts an array of serialized conversation messages back into
 * runtime ConversationMessage objects for display in the chatbot.
 */
export function deserializeConversation(
  chatLog: SerializedConversationMessage[]
): ConversationMessage[] {
  return chatLog.map(deserializeMessage)
}
